import { useFeatureAccess } from '@/hooks/useFeatureAccess';
import { useUser } from '@/contexts/UserContext';
import DayTradingSessionsList from './DayTradingSessionsList';
import DayTradingLandingPage from './DayTradingLandingPage';

export default function DayTradingPage() {
  const { hasFeature } = useFeatureAccess();
  const { isAdmin } = useUser();
  const hasDayTrading = hasFeature('dayTrading') || isAdmin;

  if (hasDayTrading) {
    return <DayTradingSessionsList />;
  }

  return <DayTradingLandingPage />;
}
